export default {
  DATE: "date",
  TIME: "time",
  Number: "number",
  ALPHA: "alpha",
};
